import { render } from "./Couple.vue?vue&type=template&id=888ba658"
import script from "./Couple.vue?vue&type=script&lang=js"
export * from "./Couple.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__